/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { BasePage } from './BasePage'
import { Logout, AuthPage } from './modules/Auth'
import ErrorsPage from './modules/ErrorsExamples/ErrorsPage'
import { Layout } from '../_metronic/layout'
import { AccessDenied } from './pages/AccessDenied'
import { hasAdminAccess } from './utils/permissions'

export function Routes() {
	const { isAuthorized, user } = useSelector(
		({ auth }) => ({
			isAuthorized: auth.user != null,
			user: auth.user,
		}),
		shallowEqual
	)

	if (!isAuthorized) {
		return (
			<Switch>
				<Route
					path='/auth/login/:status?/:auth_token?/:refresh_token?'
					component={AuthPage}
				/>
				<Route path='/error' component={ErrorsPage} />
				<Route path='/logout' component={Logout} />
				<Redirect to='/auth/login' />
			</Switch>
		)
	}

	// Authenticated but not an admin: render a full-screen access-denied page
	// OUTSIDE the Layout, so no admin chrome (sidebar/header) shows around it.
	// `/logout` stays reachable (it precedes the catch-all) so the "sign in with
	// a different account" button still works.
	if (!hasAdminAccess(user)) {
		return (
			<Switch>
				<Route path='/logout' component={Logout} />
				<Route render={() => <AccessDenied user={user} />} />
			</Switch>
		)
	}

	return (
		<Switch>
			<Redirect from='/auth' to='/' />
			<Route path='/error' component={ErrorsPage} />
			<Route path='/logout' component={Logout} />
			<Route
				path='/'
				render={() => (
					<Layout>
						<BasePage />
					</Layout>
				)}
			/>
		</Switch>
	)
}
